export function $helperGetLeftPosition({ index, length, containerWidth }) {
    const padding = 40;
    const width = containerWidth - (2 * padding);
    const offset = width / length * index;
    return {
        'left': `${ offset + padding }px`,
    };
}